import { IBaseAppointmentCategory } from '../../../interfaces';
import { BaseAppointmentCategoryToTreatmentCategoryMappingHandler } from '../../../mappings/appointment-category-to-treatment-category';
import {
  AppointmentCategorySourceEntity,
  IOasisAppointmentCategory,
  OasisAppointmentCategory,
} from '../../source/entities/appointment-categories';

export class AppointmentCategoryToTreatmentCategoryMappingHandler extends BaseAppointmentCategoryToTreatmentCategoryMappingHandler<
  OasisAppointmentCategory,
  AppointmentCategorySourceEntity
> {
  sourceEntity = new AppointmentCategorySourceEntity();
  translateFn = (
    record: IOasisAppointmentCategory
  ): IBaseAppointmentCategory => ({
    id: record.id.toString(),
    name: record.label,
  });
}
